export default __webpack_public_path__ + "static/media/zenchef.b5480a3b.png";